var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 51,
    viewBox: "0 0 112 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.1548 27.3368C90.1548 27.3368 103.175 26.2168 109.525 28.4168C111.945 29.2568 112.745 32.2868 111.125 34.2668C107.075 39.2468 94.3148 49.0568 56.2548 50.5768C56.2548 50.5768 19.1448 50.8868 2.34484 36.7368C2.34484 36.7368 -4.36516 31.4568 5.05484 29.1468C5.05484 29.1468 19.2748 27.5668 22.4948 28.0168L80.0648 27.1668L90.1548 27.3368Z",
    fill: "#CBB4FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9545 21.4964C88.9545 21.4964 85.3445 0.146406 76.8745 0.0664062C76.8745 0.0664062 70.6745 0.196406 67.0545 2.82641C67.0545 2.82641 59.9345 7.81641 48.4445 4.86641C48.4445 4.86641 44.6245 3.29641 41.9945 1.99641C41.9945 1.99641 32.8545 -2.04359 29.0645 4.11641C29.0645 4.11641 23.6645 14.0564 21.8545 28.0164L90.1445 27.3464L88.9545 21.4964Z",
    fill: "#CBB4FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9447 20.0361C88.9447 20.0361 83.4548 23.5661 57.3148 24.6861C57.3148 24.6861 28.2847 24.8061 23.0147 20.4561C23.0147 20.4561 21.7447 26.3961 21.6747 31.0761C21.6747 31.0761 18.9847 35.9161 57.2048 36.0261C57.2048 36.0261 85.7947 35.5261 90.5147 30.1861C90.5047 30.1861 89.4347 21.1561 88.9447 20.0361Z",
    fill: "#8F38EF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.fbba5e7322cf39ab67bd42b2e971d5a8.svg";
export { ForwardRef as ReactComponent };